module.exports = __webpack_public_path__ + "static/media/image2.7c33565d.jpeg";